import React from 'react';
import {Box} from '@mui/material';
import {BuilderPot} from '../../../../schema-types/BuilderPot';
import {PlanRow} from './PlanRow';
import {planFormClasses, PlanFormClassKey} from './planFormClasses';

interface ParentPlanRowProps {
  pot: BuilderPot;
  isSelected: boolean;
  sameReview?: boolean;
  summaryChildren?: React.ReactNode;
  summaryTrailing?: React.ReactNode;
  validationLevel?: PlanFormClassKey;
  children: React.ReactNode;
}

export const ParentPlanRow: React.FC<ParentPlanRowProps> = ({
  pot,
  isSelected,
  sameReview,
  summaryChildren,
  summaryTrailing,
  validationLevel,
  children,
}) => (
  <PlanRow
    id={pot.id}
    curoId={pot.curoId}
    reccId={pot.originalOvrId ?? null}
    isSelected={isSelected}
    isSubplan={false}
    sameReview={sameReview}
  >
    {summaryChildren ? (
      <Box
        width="100%"
        sx={(theme) => ({
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          pb: 2,
          bgcolor: 'background.paper',
          borderRadius: 1,
          overflow: 'hidden',
          boxShadow: theme.shadows[2],
        })}
      >
        <Box
          px={2}
          py={1}
          sx={{
            ...(validationLevel ? planFormClasses[validationLevel] : {}),
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            // mt: 1,
            // mb: 1,
          }}
        >
          {summaryChildren}
          {summaryTrailing}
        </Box>
        {children ? <>{children}</> : null}
      </Box>
    ) : (
      children
    )}
  </PlanRow>
);
